import { deepMerge } from '../utils/deepMerge';
export const mergeTheme = _ref => {
  let {
    defaultLegacyTokens,
    defaultTokens,
    customTokens
  } = _ref;
  if (!customTokens) {
    return {
      mergedTokens: deepMerge({}, defaultLegacyTokens, defaultTokens)
    };
  }
  return {
    mergedTokens: deepMerge({}, defaultLegacyTokens, defaultTokens, customTokens)
  };
};